import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ModuleFormConfig } from '../../shared/models/page-config.model';
import { BackendFormConfig, isBackendSection } from '../../shared/models/backend-form-config.model';
import { FormOptionsService } from './form-options.service';

/**
 * Resolves and applies default values for API-sourced select fields.
 * Extracted from EmployeeRegistrationPageComponent so any form page can reuse it.
 */
@Injectable({ providedIn: 'root' })
export class FormDefaultsService {

  applyApiDefaults(
    backend: BackendFormConfig,
    form: FormGroup,
    formOptions: FormOptionsService
  ): void {
    for (const step of backend.steps.filter(s => s.enabled)) {
      for (const section of step.sections) {
        if (!isBackendSection(section)) continue;
        for (const field of section.fields) {
          if (field.options_source !== 'api' || !field.options_api_key) continue;

          let defaultVal: any = null;

          if (field.default_label_match) {
            defaultVal = formOptions.resolveDefaultByLabel(
              field.options_api_key,
              field.options_value_field ?? 'id',
              field.default_label_match
            );
          } else if (field.default_value_field_match) {
            defaultVal = formOptions.resolveDefaultByFieldMatch(
              field.options_api_key,
              field.options_value_field ?? 'id',
              field.default_value_field_match.field,
              field.default_value_field_match.value
            );
          }

          if (defaultVal !== null) {
            form.get(field.id)?.setValue(defaultVal, { emitEvent: false });
          }
        }
      }
    }
  }
}
